module.exports = __webpack_public_path__ + "img/1.1a157c77.png";